<template>
  <div>
    <div class="nav1">
      <div class="row part1">
        <div class="col-lg-4">
          <div class="logo">
            <img src="@/assets/img/vector/png.png" />
          </div>
        </div>
        <div class="col-md-5 part2  d-none d-sm-block">
          <ul class="list-inline list">
            <li class="list-inline-item">
              <img src="@/assets/img/vector/Cool_03.png" />
              <div class="txt">Cool</div>
            </li>
            <li class="list-inline-item">
              <img src="@/assets/img/vector/Lol_06.png" />
              <div class="txt">Lol</div>
            </li>
            <li class="list-inline-item">
              <img src="@/assets/img/vector/Love_04.png" />
              <div class="txt">Love</div>
            </li>
            <li class="list-inline-item">
              <img src="@/assets/img/vector/OMG_03.png" />
              <div class="txt">funny</div>
            </li>
            <li class="list-inline-item">
              <img src="@/assets/img/vector/Omg_04.png" />
              <div class="txt">Wow</div>
            </li>
            <li class="list-inline-item">
              <img src="@/assets/img/vector/omg_05.png" />
              <div class="txt">OMG</div>
            </li>
            <li class="list-inline-item">
              <img src="@/assets/img/vector/Sad_icon.png" />
              <div class="txt">sad</div>
            </li>
          </ul>
        </div>
        <div class="col-md-3 part3  d-none d-sm-block">
          <span class="back-icon">
            <i class="fas fa-user-cog"></i>
          </span>
          <b-button class="button" size="lg" variant="warning">start</b-button>
        </div>
      </div>
    </div>

    <div class="nav2">
      <b-navbar toggleable="lg">
        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

        <b-collapse id="nav-collapse" is-nav>
          <b-navbar-nav>
            <b-nav-item>
              <router-link to="/">Home</router-link>
            </b-nav-item>
            <b-nav-item-dropdown class="hover" text="educational">
              <b-dropdown-item>
                <router-link to="/geography">geography</router-link>
              </b-dropdown-item>

              <b-dropdown-item>
                <router-link to="/history">history</router-link>
              </b-dropdown-item>

              <b-dropdown-item>
                <router-link to="/math">math</router-link>
              </b-dropdown-item>
              <b-dropdown-item>
                <router-link to="/animals" >animals</router-link>
              </b-dropdown-item>
              <b-dropdown-item>
                <router-link to="/computers">computers</router-link>
              </b-dropdown-item>
            </b-nav-item-dropdown>
            <b-nav-item-dropdown class="hover" text="Enjoyable">
              <b-dropdown-item>
                <router-link to="/books">books</router-link>
              </b-dropdown-item>
               <b-dropdown-item>
                <router-link to="/art">art</router-link>
              </b-dropdown-item>
              <b-dropdown-item>
                <router-link to="/cartoon">cartoon</router-link>
              </b-dropdown-item>
              <b-dropdown-item>
                <router-link to="/film">film</router-link>
              </b-dropdown-item>
              <b-dropdown-item>
                <router-link to="/sports">sports</router-link>
              </b-dropdown-item>
              <b-dropdown-item>
                <router-link to="/vehiles">vehiles</router-link>
              </b-dropdown-item>
              <b-dropdown-item>
                <router-link to="/videoG">videoG</router-link>
              </b-dropdown-item>
            </b-nav-item-dropdown>
            <b-nav-item-dropdown class="hover" text="others">
              <b-dropdown-item>
                <router-link to="/nature">nature</router-link>
              </b-dropdown-item>
              <b-dropdown-item>
                <router-link to="/politics">politics</router-link>
              </b-dropdown-item>
            </b-nav-item-dropdown>
          </b-navbar-nav>

          <!-- Right aligned nav items -->
          <b-navbar-nav class="ml-auto">
            <b-nav-item>
              <router-link to="/">
                <i class="far fa-question-circle"></i>Quiz
              </router-link>
            </b-nav-item>
            <b-nav-item right>
              <i class="fas fa-share-alt"></i>
            </b-nav-item>
            <b-nav-item right>
              <i class="fas fa-search"></i>
            </b-nav-item>
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>
    </div>
  </div>
</template>

<script>
export default {
  name: 'navbarHeader',
  mounted () {
    // start navbar with jq
    this.$nextTick(() => {
      $('.hover a').hover(function () {
        $(this)
          .next('.dropdown-menu')
          .fadeIn()
      })
      $('.dropdown').on('mouseleave', function () {
        $('.dropdown-menu').fadeOut(500)
      })
      // end navbar with jq
    })
  }
}
</script>

<style lang="scss" scoped>

</style>
